<template>
  <v-container fill-height fluid grid-list-xl>

    <v-flex>
      <app-upsert title='New Request' :config='config' :item='fullyUsed' @saved='saved'>

        <template v-slot:prebody>
          <v-alert outlined type='warning' color='deep-orange'>ATTENTION! In this section insert only the
            blister/bottle/vial/label <u>totally used</u>.</v-alert>
        </template>

      </app-upsert>

    </v-flex>

  </v-container>
</template>

<script>

import config from './config_new.js'

export default {
  data({ $store }) {
    let fullyUsed = {}
    if ($store.getters.user.site_id) {
      fullyUsed.site_id = $store.getters.user.site_id
    }
    if ($store.getters.app.protocol.id !== -1) {
      fullyUsed.protocol_id = $store.getters.app.protocol.id
    }
    return {
      config,
      fullyUsed
    }
  },
  methods: {
    saved({ data }) {
      this.$router.push(`/fullyused/${data.id}`)
    }
  }
}
</script>
